import { render, staticRenderFns } from "./layout-set.vue?vue&type=template&id=6436ef98&scoped=true&"
import script from "./layout-set.vue?vue&type=script&lang=js&"
export * from "./layout-set.vue?vue&type=script&lang=js&"
import style0 from "./layout-set.vue?vue&type=style&index=0&id=6436ef98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6436ef98",
  null
  
)

export default component.exports